<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17AbWIT/tc-custom/9781504066785.jpg?1737758121384" alt="This image is the cover for the book Tryst of Fate, The Xanth Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tryst of Fate, The Xanth Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>You’re better wed than dead—even in Xanth—in the hilariously punny new adventure in the fantasy series soon to be adapted for film and television!</b><br/>  <br/> Squid may only be a tween alien cuttlefish, but her feelings for Chaos, her Demon boyfriend, are real, which is why she’s more than ready to let someone else take over as the protagonist of this story. Being a main character is exhausting—and it’s drastically cutting down her flirting time with Chaos. But their alternate future is dependent upon their completion of one final mission . . .<br/>  <br/> Seven years from now, in another reality frame, things are not so picture perfect. Squid’s dream of happily ever after turns into happily never after when Chaos’s human host is murdered the night before their wedding. So before they become newly dead instead of newly wed, Squid and Chaos must travel through time in order to meet their maker . . .<br/>  <br/><b>Praise for Piers Anthony</b><br/>  <br/> “Piers Anthony is one of those authors who can perform magic with the ordinary. . . . [He] is a craftsman.” —<i>A Reader’s Guide to Science Fiction</i><br/>  <br/> “Anthony’s unflagging sparkle, verve and wordplay spin everyday trials of Mundane life into storytelling gold.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Piers Anthony
      </h2>
      
      <p class="authorDescription body article"> Piers Anthony is one of the world&rsquo;s most popular fantasy writers, and a&#160;<I>New York Times</I>&ndash;bestselling author twenty-one times over. His Xanth novels have been read and loved by millions of readers around the world, and he daily receives letters from his devoted fans. In addition to the Xanth series, Anthony is the author of many other bestselling works. He lives in Inverness, Florida. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?370d32e8